import React, { useEffect, useState, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { db } from "../utility/firebase";
import {
  serverTimestamp,
  doc,
  setDoc,
  getDoc,
  deleteDoc,
  updateDoc,
  arrayRemove,
} from "firebase/firestore";
import { useAuth } from "../context/AuthContext";
import { myFetchPost, apiUrl } from "../utility";
import "../css/ChatRoomDropDown.css";
import { Spinner } from "react-bootstrap";

const ChatRoomDropDown = (props) => {
  const { targetUserId, currentChatRoomId } = props;
  const { currentUser } = useAuth();

  const theRef = useRef();

  const [showMenu, setShowMenu] = useState(null);

  const [isBlocked, setIsBlocked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [showReportModal, setShowReportModal] = useState(false);
  const [showReportSuccessModal, setShowReportSuccessModal] = useState(false);
  const [showRemoveModal, setShowRemoveModal] = useState(false);

  /* report form value */
  const [reportReason, setReportReason] = useState(0);
  const [reportMessage, setReportMessage] = useState("");

  useEffect(() => {
    if (showMenu == true) {
      document.addEventListener("click", closeMenuNow);
    } else if (showMenu == false) {
      document.removeEventListener("click", closeMenuNow);
    }
    return () => {
      document.removeEventListener("click", closeMenuNow);
    };
  }, [showMenu]);

  const showMenuNow = (e) => {
    setShowMenu(!showMenu);
  };

  const closeMenuNow = (e) => {
    if (!theRef.current?.contains(e.target)) {
      setShowMenu(false);
    }
  };

  /* check if this user is blocked */
  useEffect(() => {
    if (targetUserId) {
      getDoc(doc(db, "user", currentUser.uid, "blocklist", targetUserId)).then(
        (docSnap) => {
          if (docSnap.exists()) {
            const data = docSnap.data({ serverTimestamps: "estimate" });
            if (data.blocked) {
              setIsBlocked(true);
            } else {
              setIsBlocked(false);
            }
          } else {
            setIsBlocked(false);
          }
        }
      );
    }
  }, [targetUserId]);

  const navigate = useNavigate();

  const handleReportReasonChange = (e) => {
    setReportReason(e.target.value);
  };

  const handleReportMessageChange = (e) => {
    setReportMessage(e.target.value);
  };

  const handleToggleBlock = async () => {
    try {
      // Add a new document in collection "blockList"
      setIsLoading(true);
      if (!isBlocked) {
        await setDoc(
          doc(db, "user", currentUser.uid, "blocklist", targetUserId),
          {
            blocked: !isBlocked,
            blockTime: serverTimestamp(),
          },
          { merge: true }
        );
      } else {
        await deleteDoc(
          doc(db, "user", currentUser.uid, "blocklist", targetUserId)
        );
      }
      setIsBlocked(!isBlocked);
      setIsLoading(false);
    } catch (error) {
      //alert(error);
    }
  };

  const handleRemoveChat = async () => {
    /* need to present a Modal Dialog Asking the user to confirm */
    setShowRemoveModal(false);
    try {
      await updateDoc(doc(db, "chatRooms", currentChatRoomId), {
        activeMembers: arrayRemove(currentUser.uid),
      });
      navigate("/");
    } catch (error) {
      alert('未能成功刪除對話, 請回報此問題');
    }
  };

  const handleReport = async () => {
    try {
      const token = await currentUser.getIdToken();
      const requestData = {
        targetUserId: targetUserId,
        chatRoomId: currentChatRoomId,
        reportReason: reportReason,
        reportMessage: reportMessage,
      };
      const res = await myFetchPost(`${apiUrl}/chat/report`, requestData, {
        Authorization: "Bearer " + token,
      });
      setShowReportModal(false);
      setShowReportSuccessModal(true);
    } catch (error) {
      alert(error);
    }
  };

  return (
    <div className="chatRoomDropDownWrap" ref={theRef}>
      <div onClick={showMenuNow} className="chatRoomDropDown">
        <i className="openDropDown bi bi-three-dots-vertical"></i>
        <span>管理<span className="desktopText">對話</span></span>
      </div>
      {showMenu && (
        <div className="menuWrap">
          <div className="menu">
            {isLoading && (
              <div className="spinner">
                <Spinner animation="border" role="status"></Spinner>
              </div>
            )}
            <div
              onClick={() => {
                handleToggleBlock();
              }}
              className="menuItem"
            >
              {isBlocked ? "解除封鎖用戶" : "封鎖用戶"}
            </div>
            <div
              onClick={() => {
                setShowRemoveModal(true);
              }}
              className="menuItem"
            >
              刪除對話
            </div>
            <div
              onClick={() => {
                setShowReportModal(true);
              }}
              className="menuItem"
            >
              檢舉此對話／會員
            </div>
          </div>
        </div>
      )}
      {/* Report this user */}
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showReportModal}
        onHide={() => {
          setShowReportModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>檢舉此對話／會員</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{fontSize: 15}}>
            <div style={{marginBottom: 15, fontSize: 15}}>如有懷疑，請立即檢舉！<br />共創一個安全的交易環境！</div>
            <span style={{display: "inline-block", marginBottom: 2, fontWeight: 600}}>檢舉原因：</span>
            <select name="report_reason" style={{ width: '100%', marginBottom: 12 }} class="form-select" onChange={handleReportReasonChange} value={reportReason}>
              <option value="0">--</option>
              <option value="1">懷疑詐騙</option>
              <option value="2">不禮貌言語</option>
              <option value="3">不當內容</option>
              <option value="99">其他</option>
            </select>
            <span style={{display: "inline-block", marginBottom: 2, fontWeight: 600}}>檢舉訊息：</span>
            <textarea name="report_message" style={{ minHeight: 50, width: '100%' }} class="messageInputBox form-control" value={reportMessage} onChange={handleReportMessageChange}></textarea>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowReportModal(false);
            }}
          >
            關閉
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              handleReport();
            }}
          >
            立即檢舉
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showReportSuccessModal}
        onHide={() => {
          setShowReportSuccessModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>檢舉成功</Modal.Title>
        </Modal.Header>
        <Modal.Body>感謝你的回報，這將有助於我們維護平台的安全。</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowReportSuccessModal(false);
            }}
          >
            關閉
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Remove the chatRoom */}
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showRemoveModal}
        onHide={() => {
          setShowRemoveModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>刪除對話</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          你是否確認永久刪除此對話? 如果你不想接收到對方的對話訊息,
          你可以點擊「封鎖用戶」把用戶封鎖。
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowRemoveModal(false);
            }}
          >
            關閉
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              handleRemoveChat();
            }}
          >
            立即刪除對話
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ChatRoomDropDown;
